const toggleMobileSecondaryNav = () => {
    if (document.getElementById('sidenav')) {
        const sidebar = document.getElementById('sidenav');

        sidebar.classList.toggle("sidenav--expanded");

        const sidebarButton = document.getElementById('about-the-app');

        sidebarButton.classList.toggle("sidenav--button--expanded");

        /** Put no-scroll on the body */
        document.querySelector('body').classList.toggle('no-scroll');
    }
  };

const addNavToggleHandlers = () => {
    if (document.getElementById('about-the-app')) {
        const el = document.getElementById('about-the-app');
        el.addEventListener('click', (e) => {
            toggleMobileSecondaryNav();
        });
    }
};

export const initMobileSecondary = () => {
    addNavToggleHandlers();
};

export default 'initMobileSecondary';